import SortedProductsSlice from "./slices/SortedProductsSlice";
import addonsCategoriesSlice from "./slices/addonsCategoriesSlice";
import addonsSlice from "./slices/addonsSlice";
import addressSlice from "./slices/addressSlice";
import apiSlice from "./services/apiSlice";
import appBannerSlice from "./slices/appBannerSlice";
import authReducer from "./slices/authSlice";
import branchesSlice from "./slices/branchesSlice";
import cardsSlice from "./slices/cardsSlice";
import cartSlice from "./slices/cartSlice";
import catalogProductsSlice from "./slices/catalogProductsSlice";
import catalogSlice from "./slices/catalogSlice";
import catalogsSlice from "./slices/catalogsSlice";
import categoriesSlice from "./slices/categoriesSlice";
import categorySlice from "./slices/categorySlice";
import citiesSlice from "./slices/citiesSlice";
import citySelectionSlice from "./slices/citySelectionSlice";
import { configureStore } from "@reduxjs/toolkit";
import contactFormSlice from "./slices/contactFormSlice";
import favoritesSlice from "./slices/favoritesSlice";
import gallerySlice from "./slices/gallerySlice";
import ordersSlice from "./slices/ordersSlice";
import productDetailsSlice from "./slices/productDetailsSlice";
import productNewsSlice from "./slices/productNewsSlice";
import productSortSlice from "./slices/productSortSlice";
import productsByCatalogIdSlice from "./slices/productsByCatalogIdSlice";
import productsByCategorySlice from "./slices/productsByCategorySlice";
import productsSlice from "./slices/productsSlice";
import relatedProductsSlice from "./slices/relatedProductsSlice";
import scrollSlice from "./slices/scrollSlice";
import submitOrderSlice from "./slices/submitOrderSlice";
import topSellingProductsSlice from "./slices/topSellingProductsSlice";
import userProfileSlice from "./slices/userProfileSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    newProducts: productNewsSlice,
    sortedProducts: SortedProductsSlice,
    addonsCategories: addonsCategoriesSlice,
    productDetails: productDetailsSlice,
    cards: cardsSlice,
    categories: categoriesSlice,
    catalogs: catalogsSlice,
    productsByCategory: productsByCategorySlice,
    productsByCatalogId: productsByCatalogIdSlice,
    submitOrderNew: submitOrderSlice,
    sortProducts: productSortSlice,
    products: productsSlice,
    userProfile: userProfileSlice,
    categoryData: categorySlice,
    scroll: scrollSlice,
    catalogProductsById: catalogProductsSlice,
    catalog: catalogSlice,
    topSellingProducts: topSellingProductsSlice,
    cart: cartSlice,
    addons: addonsSlice,
    orders: ordersSlice,
    addresses: addressSlice,
    cities: citiesSlice,
    gallery: gallerySlice,
    favorites: favoritesSlice,
    relatedProducts: relatedProductsSlice,
    contact: contactFormSlice,
    branches: branchesSlice,
    citySelection : citySelectionSlice,
    appBanner : appBannerSlice ,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
